import { render, staticRenderFns } from "./StockKittingToolAmountExceededIcon.vue?vue&type=template&id=95cf5cba&"
import script from "./StockKittingToolAmountExceededIcon.vue?vue&type=script&lang=js&"
export * from "./StockKittingToolAmountExceededIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip}, component.options.components || {})
